import { Injectable, inject } from '@angular/core';
//
import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { BookingModel } from '../../models/booking.model';
import { DbContext } from '../../core/utils/db-context';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { Tools } from '../../core/utils/tools';

@Injectable({
    providedIn: 'root'
})
export class BookingsRepository extends BaseEntityRepository<BookingModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(r => r.tableName === DbContext.Bookings);
    }

    async getByCustomerId(customerId: string): Promise<BookingModel[]> {
        return this.getAllForIndex(customerId);
    }

    async getByServiceCategoryId(serviceCategoryId: number, onlyCurrent = false, onYear?: number): Promise<BookingModel[]> {
        const result: BookingModel[] = [];
        const today = new Date();

        await this.database.transaction(this.config.tableName).store.openCursor().then(async (cursor) => {
            while (cursor) {
                const model = cursor.value as BookingModel;

                if (model.asd && model.asd.servicecategoryID == serviceCategoryId) {
                    if (onlyCurrent) {
                        if (new Date(model.date).getFullYear() === today.getFullYear()) {
                            result.push(model);
                        }
                    } else if (onYear) {
                        if (new Date(model.date).getFullYear() === onYear) {
                            result.push(model);
                        }
                    } else {
                        result.push(model);
                    }
                }

                cursor = await cursor.continue();
            }
        });

        return result;
    }

    async getAllForDate(providerId: string, date?: Date): Promise<BookingModel[]> {
        const result: BookingModel[] = [];
        date = date || new Date();

        await this.database.transaction(this.config.tableName).store.openCursor().then(async (cursor) => {
            while (cursor) {
                const model = cursor.value as BookingModel;

                if (model.providerID === providerId && Tools.Date.areEqual(new Date(model.date), date)) {
                    result.push(model);
                }

                cursor = await cursor.continue();
            }
        });

        return result;
    }

    async getAllByCustomerAndDate(customerId: string, date?: Date): Promise<BookingModel[]> {
        const result: BookingModel[] = [];
        date = date || new Date();

        await this.database.transaction(this.config.tableName).store.openCursor().then(async (cursor) => {
            while (cursor) {
                const model = cursor.value as BookingModel;
                if (model.customerID === customerId && Tools.Date.areEqual(new Date(model.date), date)) {
                    result.push(model);
                }

                cursor = await cursor.continue();
            }
        });

        return result;
    }

    async getByBooking(providerId: string, serviceCategoryId: string, date: Date, serviceTypeId?: number): Promise<BookingModel[]> {
        const result: BookingModel[] = [];

        await this.database.transaction(this.config.tableName).store.openCursor().then(async (cursor) => {
            while (cursor) {
                const model = cursor.value as BookingModel;

                if (model.providerID == providerId
                    && model.asd && model.asd.servicecategoryID == +serviceCategoryId
                    && Tools.Date.areEqual(new Date(model.date), date)
                    && (serviceTypeId ? model.servicetypeID == serviceTypeId : true)
                ) {
                    result.push(model);
                }

                cursor = await cursor.continue();
            }
        });

        return result;
    }
}
